import { useAppDispatch, useAppSelector } from "app/hooks";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  clearActiveTabs as clearActiveTabsRedux,
  selectTabs,
  setActiveTab as setActiveTabRedux,
} from "reduxState/tabs/tabs";

export type ActiveTab =
  | "member"
  | "importsExports"
  | "settings"
  | "memberRewards"
  | "memberCampaigns"
  | "singleSegment";

export interface ActiveTabDetails {
  id: ActiveTab;
  tab: string;
}

export const useActiveTab = (initialActiveTab: ActiveTabDetails) => {
  const navigate = useNavigate();
  const savedTabs = useAppSelector(selectTabs);
  const dispatch = useAppDispatch();
  const storedActiveTab: string | undefined = savedTabs[initialActiveTab.id];

  const [activeTab, setActiveTab] = useState<string>(
    initialActiveTab.tab !== storedActiveTab
      ? storedActiveTab || initialActiveTab.tab
      : initialActiveTab.tab,
  );

  const changeActiveTab = (path: string, id: string, tab: string) => {
    setActiveTab(tab);
    navigate(path);
  };

  const clearActiveTabs = useCallback(() => {
    dispatch(
      clearActiveTabsRedux({
        id: initialActiveTab.id,
      }),
    );
  }, [dispatch, initialActiveTab.id]);

  useEffect(() => {
    if (activeTab) {
      dispatch(
        setActiveTabRedux({
          id: initialActiveTab.id,
          activeTab: activeTab,
        }),
      );
    } else {
      clearActiveTabs();
    }
  }, [activeTab, clearActiveTabs, initialActiveTab.id, dispatch]);

  return {
    activeTab: activeTab,
    clearActiveTabs,
    changeActiveTab,
  };
};
